import { render, staticRenderFns } from "./CompetenceModal.vue?vue&type=template&id=68ff01a1&scoped=true"
import script from "./CompetenceModal.vue?vue&type=script&lang=js"
export * from "./CompetenceModal.vue?vue&type=script&lang=js"
import style0 from "./CompetenceModal.vue?vue&type=style&index=0&id=68ff01a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff01a1",
  null
  
)

export default component.exports